import type { MetaMatches } from '@remix-run/react/dist/routeModules'

export const getPageTitle = (matches: MetaMatches) => {
    if (!Array.isArray(matches)) return { title: 'TechDisc' }

    const filteredMatches = matches.filter(match => match.handle?.breadcrumb)

    return {
        title:
            filteredMatches.length > 0
                ? `${filteredMatches.at(-1)?.handle?.breadcrumb?.title} - TechDisc`
                : 'TechDisc',
    }
}
